module.exports = __webpack_public_path__ + "static/img/en_US2.07c6c48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/en_US2.png
// module id = GMIf
// module chunks = 1